import { render, staticRenderFns } from "./ArgumentReference.vue?vue&type=template&id=6d202400&"
import script from "./ArgumentReference.vue?vue&type=script&lang=js&"
export * from "./ArgumentReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports